const ctaTypes = [
  {
    label: 'Nenhum',
    value: null,
  },
  {
    label: 'Aluno',
    value: 'student',
  },
  {
    label: 'Professor',
    value: 'teacher',
  },
]

const ctaTypesTranslations = {
  null: 'Nenhum',
  student: 'Aluno',
  teacher: 'Professor',
}

export { ctaTypes, ctaTypesTranslations }
